import request from '@/utils/request'
import baseUrl from '@/api/baseUrl'
import commonJs from '@/utils/common'
export default {
	/**
	 * 集控策略列表
	 * @param {page} 第几页
	 * @return {pageSize} 每页数量
	**/
	strategyList( params={} ) {
		params = commonJs.obj.removeNullKey(params)
		return request({
	    url: baseUrl + '/jkst/Strategy',
	    method: 'GET',
	    params
	  })
	},

	/**
	 * strategy 添加
	**/
	strategyAdd(data){
		return request({
			url: baseUrl + '/jkst/Strategy',
			method:'POST',
			data
		})
	},

	/**
	 * strategy 编辑
	**/
	strategyEdit(id, data){
		return request({
			url: baseUrl + '/jkst/Strategy/'+id,
			method:'PUT',
			data
		})
	},
	/**
	 * strategy 删除
	**/
	strategyDel(id){
		return request({
			url: baseUrl + '/jkst/Strategy/'+id,
			method:'DELETE'
		})
	},

	/**
	 * 策略的启用与停止
	 * @param {ste} 策略状态1启用2停用
	**/
	strategySwitch(id, data){
		return request({
			url: baseUrl + '/jkst/strategySwitch/'+id,
			method: 'POST',
			data
		})
	},

	/**
	 * 设备恢复策略
	 * @param {id} 集控的id
	 * @param {stg_id} 关联字段,集控策略的id,默认0无关联
	 * @param {ms} 模式1.手动2.自动, 不传递默认恢复成自动
	**/
	recoveryStrategy(data){
		return request({
			url: baseUrl + '/jkst/recoveryStrategy',
			method:'POST',
			data
		})
	},

	/**
	 * 查询没有绑定过策略的集控列表
	 * @param {type} 1表示查询没有绑定过的集控 2查询全部
	 * @param {is_support_offline_stg} 是否支持离线策略1支持0不支持 2是忽略查询全部

	**/
	getSelectConcentrator( params={} ) {
		params = commonJs.obj.removeNullKey(params)
		return request({
	    url: baseUrl + '/jk/getSelectConcentrator',
	    method: 'GET',
	    params
	  })
	},
}